import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Import, ImportStatus } from "types/Import";

type Props = {
  item: Import;
};

function ImportObservationGridContentCard({ item }: Props) {
  const { t } = useTranslation();

  const { parsedContent, status, error } = item;

  const nbSections = useMemo(() => {
    if (parsedContent?.data && parsedContent?.data) {
      return parsedContent?.data.length;
    }
    return 0;
  }, [parsedContent]);

  return parsedContent && nbSections > 0 && status !== ImportStatus.ERROR ? (
    <div className="flex flex-col">
      <span>{`${t("import.nbTotalSections")} ${nbSections}`}</span>
    </div>
  ) : status === ImportStatus.ERROR && error ? (
    <span>
      <strong>{t("import.errorDetail")}</strong>
      {t(`import.errors.${item.error?.key}`)}
    </span>
  ) : (
    <span>
      <strong>{t("import.errorUnknown")}</strong>
    </span>
  );
}

export default ImportObservationGridContentCard;
